import { gql } from '@apollo/client'

export const GET_OPPORTUNITY_TYPES = gql`
  query {
    opportunityTypes {
      id
      name
    }
  }
`